<div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12" *ngIf="carrierId === null || carrierId === undefined">
        <div class="usa-alert usa-alert--success usa-alert--no-icon bg-accent-warm maxw-full" *ngIf="message" hidden="modal.hide">
            <div class="usa-alert__body">
                <p class="usa-alert__text">
                    Unable to determine your carrierId, please click <a class="alert-link" [routerLink]="['/duns']" [queryParams]="{rateType: 'FRT'}">FRT Rate Filing</a>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="grid-row" *ngIf="carrierId !== null && carrierId !== undefined">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="type">Rate Type</label>
        <select id="type" class="usa-select maxw-full" (change)="layOutChange($event)">
            <option [value] = '18' selected>Freight - TL</option>
            <option [value] = '19'>Freight - LTL</option>
            <option [value] = '20'>Fleet Vehicles - Domestic 1</option>
            <option [value] = '21'>Fleet Vehicles - Domestic 2</option>
            <option [value] = '22'>Fleet Vehicles - Domestic 3</option>
            <option [value] = '23'>Fleet Vehicles - International 1</option>
            <option [value] = '24'>Fleet Vehicles - International 2</option>
            <option [value] = '25'>Fleet Vehicles - International 3</option>
          </select>
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <label class="usa-label">Status: U  - Unmodified, N - New, M- Modified</label>
    </div>
</div>
<div class="grid-row" *ngIf="showExport">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <button type="usa-button" (click)="onBtExport()">Export to CSV</button>
    </div>
</div>
<div class="grid-row" *ngIf="carrierId !== null && carrierId !== undefined && this.rateId !== undefined && this.rateId !== null">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <ag-grid-angular class="ag-theme-alpine" id="myGrid" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [components]="components" [gridOptions]="gridOptions" [rowSelection]="rowSelection" [suppressDragLeaveHidesColumns]="true" [domLayout]="domLayout"
            [overlayNoRowsTemplate]="overlayNoRowsTemplate" [overlayLoadingTemplate]="overlayLoadingTemplate" [frameworkComponents]="frameworkComponents" (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>
</div>